import React, { useContext } from 'react';
import { TEDEKBokforderVariantEnum } from '../../../../../../../globalQueryTypes';
import { BusinessDataFormContext } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import BokforderContext from '../BokforderContext/BokforderContext';
import BokforderAreYouSureDialog from './BokforderAreYouSureDialog';

interface IProps {}

export const BokforderAreYouSureDialogWrapper: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const bokforderContext = useContext(BokforderContext);
  const formContext = useContext(BusinessDataFormContext);

  return (
    <>
      <BokforderAreYouSureDialog
        boldWarningText="Dina ändringar kommer att gå förlorade"
        open={bokforderContext.areYouSureModalOpen}
        setOpen={bokforderContext.setAreYouSureModalOpen}
        title="Är du säker?"
        warningText="Är du säker på att du vill göra detta?"
        yesCallback={() => {
          if (
            bokforderContext.bokforderVariant === TEDEKBokforderVariantEnum.MALL
          ) {
            formContext?.formStateDispatch({ type: 'RESET' });
            formContext?.formStateDispatch({ type: 'ENTER_EDITMODE' });
          } else {
            bokforderContext.resetBokforder();
          }

          bokforderContext?.areYouSureModalCallback.callback();
        }}
      />
    </>
  );
};
